@if (isLoading) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (isLoadingParkings) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (!isLoading) {
<div class="md:px-3 lg:px-28 pt-4 bg-white h-full px-5">
  @if (!hasSpecialParams) {
  <div class="py-4 px-2 sm:px-4 md:px-8 lg:px-12">
    <button class="gap-2 flex items-center" (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="size-6 stroke-[#0D6EFD]">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
      </svg>
      <p class="font-medium text-md text-[#0D6EFD]">
        {{ "PARKIFLY.CONFIRMATION.BOOKING_SUMMARY" | transloco }}
      </p>
    </button>
  </div>
  }
  <div
    class="Content w-full justify-end items-start gap-8 flex xl:flex-row flex-col pt-0 px-2 sm:px-4 md:px-8 lg:px-12">
    <div class="Frame808 flex-col justify-start items-start gap-4 inline-flex w-full">
      <div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex"
        [class.opacity-50]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"
        [style.cursor]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout' ? 'not-allowed' : 'default'">
        <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">
          {{'PLACEHOLDER.DEPARTURE' | transloco}}
        </div>
        <!-- Departure -->
        @if(advancedBooking){
        @if (!showDepHotel) {
        <div
          class="Frame792 self-stretch w-full rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
          <div class="Frame799 self-stretch w-full justify-start items-start flex flex-col lg:flex-row">
            <div
              class="Frame793 grow shrink basis-0 w-full flex flex-col items-start px-1 sm:px-3 py-3 border-zinc-200 justify-start gap-2.5">
              <app-radio-btn [inputFormControl]="this.handleBookingGroup.controls.departureType"
                [options]="[{ value: 'true', viewValue: ('FLIGHT.FLIGHT' | transloco) }, { value: 'false', viewValue: ('INTERNAL_BOOKING.HOTEL' | transloco) }]"
                (onChange)="onDepartureTypeChange($event)"
                [disabled]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"></app-radio-btn>
              <div
                class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex cursor-pointer">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input label="{{ 'FORM.DEPARTURE_DATE' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.departureDate"
                    (click)="booking?.parkingStatus !== 'Checkin' && booking?.parkingStatus !== 'Checkout' && openDatepicker('departureDate')"
                    [disabled]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"
                    [readonly]="true" class="w-full cursor-pointer"></pf-text-input>
                </div>
              </div>
              <div
                (click)="booking?.parkingStatus !== 'Checkin' && booking?.parkingStatus !== 'Checkout' && openFlightDialog('departure', 'departureDate', 'departureFlight')"
                class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex cursor-pointer"
                [style.pointer-events]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout' ? 'none' : 'auto'">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input label="{{ 'PARKING_ORDER_TIME_EDIT.DEPARTURE_FLIGHT' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.departureFlight"
                    [disabled]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"
                    [readonly]="true" class="w-full cursor-pointer"></pf-text-input>
                </div>
              </div>
              <div
                class="Bagage mx-2  self-stretch  rounded-xl border border-neutral-300 justify-start items-end inline-flex"
                [style.pointer-events]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout' ? 'none' : 'auto'"
                (click)="bookingDetails?.additionalServices?.length > 0 && checkServicesBeforeFieldChange()">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-select label="{{ 'FORM.ARRIVAL_TIME' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.departureTimeAtParking"
                    [options]="arriveAtParkingOptions"
                    [disabled]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"
                    class="w-full"></pf-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        @if (showDepHotel) {
        <div
          class="Frame792 self-stretch w-full rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
          <div class="Frame799 self-stretch w-full justify-start items-start flex flex-col lg:flex-row">
            <div
              class="Frame793 grow shrink basis-0 w-full flex flex-col items-start px-1 sm:px-3 py-3 border-zinc-200 justify-start gap-2.5">
              <app-radio-btn [inputFormControl]="this.handleBookingGroup.controls.departureType"
                [options]="[{ value: 'true', viewValue: ('FLIGHT.FLIGHT' | transloco) }, { value: 'false', viewValue: ('INTERNAL_BOOKING.HOTEL' | transloco) }]"
                (onChange)="onDepartureTypeChange($event)"
                [disabled]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"></app-radio-btn>
              <div
                class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex cursor-pointer">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input label="{{ 'FORM.DEPARTURE_DATE' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.departureDate"
                    (click)="booking?.parkingStatus !== 'Checkin' && booking?.parkingStatus !== 'Checkout' && openDatetimePicker('departureDate')"
                    [disabled]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"
                    [readonly]="true" class="w-full cursor-pointer"></pf-text-input>
                </div>
              </div>
              <div
                class="Bagage mx-2  self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex"
                (click)="bookingDetails?.additionalServices?.length > 0 && checkServicesBeforeFieldChange()">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-select label="{{ 'HANDLE_BOOKING.DEPARTURE_HOTEL' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.departureHotel" [options]="hotelOptions"
                    [disabled]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"
                    class="w-full"></pf-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        } @else {
        <div class="Frame799 self-stretch w-full justify-start items-start flex flex-col lg:flex-row">
          <div
            class="Frame793 grow shrink basis-0 w-full flex flex-col items-start border-zinc-200 justify-start gap-2.5 px-1 sm:px-3 py-2">
            <div
              class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex cursor-pointer">
              <div
                class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                <pf-text-input label="{{ 'HANDLE_BOOKING.DEPARTURE_DATE_TIME' | transloco }}"
                  [inputFormControl]="this.handleBookingGroup.controls.departureDate"
                  (click)="booking?.parkingStatus !== 'Checkin' && booking?.parkingStatus !== 'Checkout' && openDatetimePicker('departureDate')"
                  [disabled]="booking?.parkingStatus === 'Checkin' || booking?.parkingStatus === 'Checkout'"
                  [readonly]="true" class="w-full cursor-pointer"></pf-text-input>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      <!-- Arrival -->
      <div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex"
        [class.opacity-50]="booking?.parkingStatus === 'Checkout'"
        [style.cursor]="booking?.parkingStatus === 'Checkout' ? 'not-allowed' : 'default'">
        <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">{{'PLACEHOLDER.ARRIVAL'
          | transloco}}</div>
        @if(advancedBooking){
        @if (!showArrHotel) {
        <div
          class="Frame792 self-stretch w-full rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
          <div class="Frame799 self-stretch w-full justify-start items-start flex flex-col lg:flex-row">
            <div
              class="Frame793 grow shrink basis-0 w-full flex flex-col items-start px-1 sm:px-3 py-3 border-zinc-200 justify-start gap-2.5">
              <app-radio-btn [inputFormControl]="this.handleBookingGroup.controls.arrivalType"
                [options]="[{ value: 'true', viewValue: ('FLIGHT.FLIGHT' | transloco) }, { value: 'false', viewValue: ('INTERNAL_BOOKING.HOTEL' | transloco) }]"
                (onChange)="onArrivalTypeChange($event)"
                [disabled]="booking?.parkingStatus === 'Checkout'"></app-radio-btn>
              <div
                class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex cursor-pointer">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input label="{{ 'FORM.ARRIVAL_DATE' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.arrivalDate"
                    (click)="booking?.parkingStatus !== 'Checkout' && openDatepicker('arrivalDate')"
                    [disabled]="booking?.parkingStatus === 'Checkout'" [readonly]="true"
                    class="w-full cursor-pointer"></pf-text-input>
                </div>
              </div>
              <div
                (click)="booking?.parkingStatus !== 'Checkout' && openFlightDialog('arrival', 'arrivalDate', 'arrivalFlight')"
                class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex cursor-pointer"
                [style.pointer-events]="booking?.parkingStatus === 'Checkout' ? 'none' : 'auto'">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input label="{{ 'PARKING_ORDER_TIME_EDIT.ARRIVAL_FLIGHT' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.arrivalFlight"
                    [disabled]="booking?.parkingStatus === 'Checkout'" [readonly]="true"
                    class="w-full cursor-pointer"></pf-text-input>
                </div>
              </div>
              <div
                class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input label="{{ 'FORM.PARKING_END_TIME' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.arrivalTimeAtParking"
                    [disabled]="booking?.parkingStatus === 'Checkout'" [readonly]="true"
                    class="w-full cursor-pointer"></pf-text-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        @if (showArrHotel) {
        <div
          class="Frame792 self-stretch w-full rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
          <div class="Frame799 self-stretch w-full justify-start items-start flex flex-col lg:flex-row">
            <div
              class="Frame793 grow shrink basis-0 w-full flex flex-col items-start px-1 sm:px-3 py-3 border-zinc-200 justify-start gap-2.5">
              <app-radio-btn [inputFormControl]="this.handleBookingGroup.controls.arrivalType"
                [options]="[{ value: 'true', viewValue: ('FLIGHT.FLIGHT' | transloco) }, { value: 'false', viewValue: ('INTERNAL_BOOKING.HOTEL' | transloco) }]"
                (onChange)="onArrivalTypeChange($event)"
                [disabled]="booking?.parkingStatus === 'Checkout'"></app-radio-btn>
              <div
                class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex cursor-pointer">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-text-input label="{{ 'HANDLE_BOOKING.ARRIVAL_DATE_TIME' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.arrivalDate"
                    (click)="booking?.parkingStatus !== 'Checkout' && openDatetimePicker('arrivalDate')"
                    [disabled]="booking?.parkingStatus === 'Checkout'" [readonly]="true"
                    class="w-full cursor-pointer"></pf-text-input>
                </div>
              </div>
              <div
                class="Bagage mx-2  self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex"
                (click)="bookingDetails?.additionalServices?.length > 0 && checkServicesBeforeFieldChange()">
                <div
                  class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                  <pf-select label="{{ 'HANDLE_BOOKING.ARRIVAL_HOTEL' | transloco }}"
                    [inputFormControl]="this.handleBookingGroup.controls.arrivalHotel" [options]="hotelOptions"
                    [disabled]="booking?.parkingStatus === 'Checkout'" class="w-full"></pf-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        } @else {
        <div class="Frame799 self-stretch w-full justify-start items-start flex flex-col lg:flex-row">
          <div
            class="Frame793 grow shrink basis-0 w-full flex flex-col items-start border-zinc-200 justify-start gap-2.5 px-1 sm:px-3 py-2">
            <div
              class="Bagage mx-2 self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex cursor-pointer">
              <div
                class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
                <pf-text-input label="Arrival Date & Time"
                  [inputFormControl]="this.handleBookingGroup.controls.arrivalDate"
                  (click)="booking?.parkingStatus !== 'Checkout' && openDatetimePicker('arrivalDate')"
                  [disabled]="booking?.parkingStatus === 'Checkout'" [readonly]="true"
                  class="w-full cursor-pointer"></pf-text-input>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      <!-- Retry Button -->
      @if (showRetryButton && !isLoadingParkings) {
      <div class="w-full">
        <button type="button" (click)="retryParkingAvailability()"
          class="btn-yellow-25">
          Click here to check parking availability
        </button>
      </div>
      }
      <div class="Frame805 self-stretch flex-col justify-start items-start gap-4 flex" [class.opacity-50]="true">
        <div class="Biluppgifter text-black text-xl font-medium  leading-loose">
          {{ 'PARKING_EDIT.PARKING_SITE'
          | transloco }}
        </div>
        <div class="Bagage mx-2  self-stretch rounded-xl border border-neutral-300 justify-start items-end inline-flex">
          <div class="Frame793 grow shrink basis-0 h-20 pt-3 border-zinc-200 justify-start items-start gap-2.5 flex">
            <pf-text-input label="{{ 'PARKING_EDIT.PARKING_SITE' | transloco }}"
              [inputFormControl]="this.handleBookingGroup.controls.parkingSite" [disabled]="true"
              class="w-full"></pf-text-input>
          </div>
        </div>
      </div>
      @if (parkingOutOfOrder && !isLoadingParkings) {
      <div class="self-stretch p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <div class="flex items-start gap-2">
          <mat-icon class="text-red-500 min-width-fit-content">error</mat-icon>
          <div class="text-md text-blue-800">
            <div class="font-semibold mb-1">{{ 'HANDLE_BOOKING.PARKING_OUT_OF_ORDER' | transloco }}</div>
            <div class="text-md text-blue-600">{{ 'HANDLE_BOOKING.CONTACT_CUSTOMER_SUPPORT' | transloco
              }}<br>{{"PARKIFLY.CONFIRMATION.CONTACT_US" |
              transloco}}:
              @if(site?.toLowerCase() === 'flygets' || site?.toLowerCase() === 'nazar' ||
              site?.toLowerCase() === 'tui') {
              010-330 03 33
              } @else if(site?.toLowerCase() === 'skavsta') {
              010-330 03 33
              } @else if(site?.toLowerCase() === 'quality hotel arlanda xpo parkering' ||
              site?.toLowerCase() === 'quality-xpo-arlanda' || site?.toLowerCase() === 'quality') {
              08-595 11113
              }@else if(site?.toLowerCase() === 'aiden hotel arlanda parkering' ||
              site?.toLowerCase() === 'aiden-short-term' || site?.toLowerCase() === 'aiden') {
              010-330 03 33
              }
            </div>
          </div>
        </div>
      </div>
      }
      <!-- Price Comparison -->
      @let selectedValue = selectedParking | async;
      @if(selectedValue){
      @if (additionalPaymentAmount > 0 && selectedValue && (selectedValue?.availableParkingSpots > 0 ||
      selectedValue?.availableParkingSpots <=0 && (booking?.parkingStatus==='Checkin' ))) { <div
        class="Frame805 self-stretch flex-col justify-start items-start gap-4 flex">
        <div class="rounded-2xl flex-col justify-start items-start flex warning-box-gradient">
          <div class="flex justify-between items-center w-full">
            <div class="flex flex-col">
              <h3 class="text-600-e65100">{{
                'HANDLE_BOOKING.ADDITIONAL_PAYMENT' | transloco: { amount: (additionalPaymentAmount) }
                }}
              </h3>
            </div>
          </div>
        </div>
    </div>
    }
    @if (0 > additionalPaymentAmount && isParkingMoreThan24HoursAway && selectedValue &&
    (selectedValue?.availableParkingSpots > 0 || selectedValue?.availableParkingSpots <=0 &&
      (booking?.parkingStatus==='Checkin' ))) { <div
      class="self-stretch p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <div class="flex items-start gap-2">
        <mat-icon class="text-[#fbde08] min-width-fit-content">lightbulb</mat-icon>
        <div class="text-md text-blue-800">
          <div class="font-semibold mb-1">{{ 'HANDLE_BOOKING.BETTER_DEAL_TITLE' | transloco }}</div>
          <div class="mb-2">{{ 'HANDLE_BOOKING.BETTER_DEAL_DESC' | transloco: { amount:
            additionalPaymentAmount * -1 } }}</div>
          <div class="text-sm text-blue-600">{{ 'HANDLE_BOOKING.BETTER_DEAL_WARNING' | transloco }}</div>
        </div>
      </div>
      <div class="flex justify-end mt-3">
        <button type="button" (click)="cancelOrder()"
          class="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors">
          {{ 'ORDER_DETAILS.BUTTONS.CANCEL_ORDER' | transloco }}
        </button>
      </div>
  </div>
  }
  @if (selectedValue && (selectedValue?.availableParkingSpots <=0 && (booking?.parkingStatus !=='Checkin' ))) { <div
    class="self-stretch p-3 bg-blue-50 border border-blue-200 rounded-lg">
    <div class="flex items-start gap-2">
      <mat-icon class="text-red-500 min-width-fit-content">error</mat-icon>
      <div class="text-md text-blue-800">
        <div class="font-semibold mb-1">{{ 'HANDLE_BOOKING.NO_PARKING_AVAILABLE' | transloco }}</div>
        <div class="text-md text-blue-600">{{ 'HANDLE_BOOKING.CONTACT_CUSTOMER_SUPPORT' | transloco
          }}<br>{{"PARKIFLY.CONFIRMATION.CONTACT_US" |
          transloco}}:
          @if(site?.toLowerCase() === 'flygets' || site?.toLowerCase() === 'nazar' ||
          site?.toLowerCase() === 'tui') {
          010-330 03 33
          } @else if(site?.toLowerCase() === 'skavsta') {
          010-330 03 33
          } @else if(site?.toLowerCase() === 'quality hotel arlanda xpo parkering' ||
          site?.toLowerCase() ===
          'quality-xpo-arlanda' || site?.toLowerCase() === 'quality') {
          08-595 11113
          } @else if(site?.toLowerCase() === 'aiden hotel arlanda parkering' ||
          site?.toLowerCase() === 'aiden-short-term' || site?.toLowerCase() === 'aiden') {
          010-330 03 33
          }
        </div>
      </div>
    </div>
</div>
}
}
<!-- Passengers -->
@if(booking.passengers != null) {
<div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
  <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">
    {{'PARKIFLY.DETAILS.YOU_AND_COMPANY' |
    transloco}}</div>
  <div class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
    <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
      <div class="Frame798 grow shrink basis-0 h-20 justify-start items-start flex w-full">
        <div class="Frame793 grow shrink basis-0 pt-3 h-20 border-zinc-200 justify-start items-start gap-2.5 flex">
          <pf-select label="{{'PARKIFLY.FORM.PERSONS' | transloco}}"
            [inputFormControl]="this.handleBookingGroup.controls.persons" [options]="passengers"
            class="w-full"></pf-select>
        </div>
      </div>
    </div>
  </div>
</div>
}
<!-- Baggage -->
@if (advancedBooking) {
<div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
  <div class="DuOchDittResesLlskap text-black text-xl font-medium  leading-loose">
    {{'FORM.BAGGAGE' | transloco}}</div>
  <div class="Frame792 self-stretch  rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
    <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
      <div
        class="Frame793 grow shrink basis-0 flex items-center px-1 sm:px-3 h-20 border-zinc-200 justify-start items-start gap-2.5 flex">
        <app-radio-btn class="margin-top-neg-15px" [inputFormControl]="this.handleBookingGroup.controls.baggage"
          [options]="[{ value: 1, viewValue: 'PARKIFLY.MANAGE_BOOKING.YES' | transloco }, { value: 0, viewValue: 'PARKIFLY.MANAGE_BOOKING.NO' | transloco }]"></app-radio-btn>
      </div>
    </div>
  </div>
</div>
}
<div class="Frame804 self-stretch flex-col justify-start items-start gap-4 flex">
  <div class="DuOchDittResesLlskap text-black text-xl font-medium leading-loose">
    {{'PARKIFLY.DETAILS.TERMS' | transloco}}
  </div>
  <div class="Frame792 self-stretch rounded-2xl border border-zinc-200 flex-col justify-start items-start flex">
    <div class="Frame799 self-stretch justify-start items-start flex flex-col lg:flex-row">
      <div class="Frame793 grow shrink basis-0 flex flex-col px-3 py-3 border-zinc-200 justify-start gap-2.5">
        <div class="Checkbox justify-start items-center gap-2 inline-flex">
          <div class="FormFieldsCheckboxInput w-4 relative flex-shrink-0">
            <input type="checkbox" [(ngModel)]="consent" class="w-4 h-4 border border-gray-300">
          </div>
          <div class="Title text-blue-900 text-sm font-medium leading-none">
            {{'PARKIFLY.FORM.TERMS' | transloco}}</div>
        </div>
        <div class="Checkbox justify-start items-center gap-2 inline-flex">
          <div class="w-4 flex-shrink-0"></div>
          <div
            class="Title text-blue-600 text-sm font-medium leading-normal tracking-tight cursor-pointer hover:underline"
            (click)="$event.stopPropagation(); openTermsModal();">
            {{'PARKIFLY.FORM.READ_MORE' | transloco}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
<div>
  <div class="pt-4 pb-8 md:pt-8 md:flex md:justify-between md:flex-row-reverse gap-2 px-2 sm:px-4 md:px-8 lg:px-12">
    <button
      class="w-full px-8 py-3 rounded-[4px] font-medium text-md leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0 bg-[#1B3777] hover:bg-[#1B3777] text-[#FFFFFF] disabled:bg-[#dcdcdc] disabled:text-[#4B4A4A] disabled:cursor-not-allowed disabled:opacity-70"
      (click)="updateBooking()" [disabled]="!formHasChanges || !consent || isParkingUnavailable || isLoading">
      {{ 'PARKIFLY.MANAGE_BOOKING.UPDATE_BOOKING' | transloco }}
    </button>
    <button
      class="w-full px-8 py-3 cancel-button rounded-[4px] font-medium text-md leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0 text-white"
      (click)="goBack()">
      {{ 'FORM.CANCEL_CHANGES' | transloco }}
    </button>
  </div>
</div>
</div>
}